export default __webpack_public_path__ + "static/media/ugb.828efb57.svg";